import React from "react"
import { connect } from "react-redux"
import OpenOrders from "../../components/shop/open-orders-button"

const mapStateToProps = state =>({
  ...state.currentShop.openOrders,
  itemsCount: state.entities.openOrders.allIds ? state.entities.openOrders.allIds.length : 0
})

const mapDispatchToProps = dispatch => ({
  onClick: () => dispatch({type: "OPEN_ORDER.OPEN_LIST"})
})

export default connect(mapStateToProps, mapDispatchToProps)(OpenOrders)

